<template>
  <div class="solution-content-container">
    <div class="solution-content-one">
      <div class="title-container">
        <div class="main-title wow fadeInLeft">
          <span>智慧医疗服务解决方案</span>
        </div>
        <div class="sub-title wow fadeInLeft">
          <span>通过专业的云平台搭建为医疗机构多样化的业务提供稳定支撑</span>
        </div>
      </div>
      <div class="solution-card-container">
        <div
          class="solution-card-wrapper wow"
          :class="{
            fadeInLeft:index==0||index==3,
            fadeInUp:index==1||index==4,
            fadeInRight:index==2||index==5
          }"
          v-for="(item,index) in solutionData"
          :key="item.title"
        >
          <div class="solution-header">
            <div class="title">
              <img :src="item.logoUrl" alt="" />
              <span>{{ item.title }}</span>
            </div>
          </div>
          <div class="solution-body">
            <div
              class="solution-content-container"
              v-for="childItem in item.content"
              :key="childItem.title"
            >
              <div class="solution-title">
                <span>{{ childItem.title }}</span>
              </div>
              <div class="solution-content">
                <span>{{ childItem.txt }}</span>
              </div>
            </div>
          </div>
          <div class="get-btn-container">
            <div class="get-btn wave">
              <span>获取方案</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="solution-content-two">
      <div class="title-container">
        <div class="main-title wow fadeInUp">
          <span>企业转型一站式解决方案</span>
        </div>
        <div class="sub-title wow fadeInUp">
          <span
            >为传统中小企业及医疗机构，提供智慧转型方案，提升服务效率和产品价值</span
          >
        </div>
        <div class="solution-card-container wow fadeInUp">
          <div
            class="solution-card-wrapper"
            v-for="item in oneStopSolutionData"
            :key="item.title"
          >
            <div class="logo">
              <img :src="item.logoUrl" alt="" />
            </div>
            <div class="card-title">
              <span>{{ item.title }}</span>
            </div>
            <div class="card-txt">
              <span>{{ item.txt }}</span>
            </div>
            <div class="card-desc-container">
              <div
                class="card-desc"
                v-for="childItem in item.desc"
                :key="childItem"
              >
                <span>{{ childItem }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      solutionData: [
        {
          title: "客户数据智能化解决方案",
          logoUrl: require("@/assets/images/icon-solution1.png"),
          content: [
            {
              title: "客户分资源登记",
              txt: "保留客户每条可溯源记录，使检索信息更加高效",
            },
            {
              title: "客户数据统一关联",
              txt: "资源信息统一关联至客户，杜绝数据丢失、重复等问题",
            },
            {
              title: "客户数据可视化",
              txt: "精准分析客户数据信息，为销售和服务提供可靠数据支撑",
            },
          ],
        },
        {
          title: "客户全程随访解决方案",
          logoUrl: require("@/assets/images/icon-solution2.png"),
          content: [
            {
              title: "线上电话外呼",
              txt: "线上快速外呼客户电话，保留与客户的通话记录和相关信息",
            },
            {
              title: "线上短信群发",
              txt: "线上短信批量群发，通过定义短信模板，批量送达至客户",
            },
            {
              title: "个性化短信提示",
              txt: "短信支持变量，内容灵活，可适应各种业务场景",
            },
          ],
        },
        {
          title: "客户预约挂号解决方案",
          logoUrl: require("@/assets/images/icon-solution3.png"),
          content: [
            {
              title: "小程序自主预约",
              txt:
                "提供微信、支付宝小程序快速自主预约入口，实现客户低成本便捷预约",
            },
            {
              title: "平台挂号系统",
              txt:
                "可关联CRM系统，实现平台客户快速挂号，及新客户的便捷登记挂号",
            },
            {
              title: "预约定额配置",
              txt: "灵活配置预约配额，实现人员和资源的有效分配的最大化",
            },
          ],
        },
        {
          title: "客户服务消费解决方案",
          logoUrl: require("@/assets/images/icon-solution4.png"),
          content: [
            {
              title: "项目开单与核销",
              txt: "客户购买项目服务的销售开单系统，开单核销一体化",
            },
            {
              title: "套餐销售订购",
              txt: "通过记录客户就诊相关信息，订购客户定制化套餐",
            },
            {
              title: "销售数据统计",
              txt: "精准分析客户消费数据信息，为销售和服务提供可靠数据支撑",
            },
          ],
        },
        {
          title: "视频直播解决方案",
          logoUrl: require("@/assets/images/icon-solution5.png"),
          content: [
            {
              title: "商品/服务关联",
              txt: "直播中可关联推荐商品和服务，实现流量的有效变现",
            },
            {
              title: "医患直播互动",
              txt: "实现患者与医生互动，通过问答等方式在线解决疑难问题",
            },
            {
              title: "直播录像回看",
              txt: "可保存直播内容，让专业内容的无限制输出与留存",
            },
          ],
        },
        {
          title: "医疗服务营销解决方案",
          logoUrl: require("@/assets/images/icon-solution6.png"),
          content: [
            {
              title: "小程序商城",
              txt: "依托与微信及支付宝大平台流量，使交易量和交易流程获得保障",
            },
            {
              title: "服务/卡券",
              txt: "建立服务的产品化销售模式，为客户提供一站式服务体系",
            },
            {
              title: "电商直播",
              txt: "搭建自有电商直播平台，实现数字化零售转型，突破传统销售模式",
            },
          ],
        },
      ],
      oneStopSolutionData: [
        {
          title: "产品咨询",
          logoUrl: require("@/assets/images/icon-solution7.png"),
          txt: "为中小企业提供专业的企业转型升级以及产品构建方案",
          desc: ["多年行业经验", "一对一服务"],
        },
        {
          title: "品牌建设",
          logoUrl: require("@/assets/images/icon-solution8.png"),
          txt: "提供品牌设计服务，建立自有品牌的继承与创新发展体系",
          desc: ["多方案选择", "服务保障"],
        },
        {
          title: "系统研发",
          logoUrl: require("@/assets/images/icon-solution9.png"),
          txt: "提供多平台的软件开发服务，中后台系统开发",
          desc: ["多平台适配", "专业团队"],
        },
        {
          title: "运营推广",
          logoUrl: require("@/assets/images/icon-solution10.png"),
          txt: "结合多年各行业经验，提供产品运营推广和业务咨询服务",
          desc: ["多行业经验", "精准分析"],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.solution-content-container {
  .solution-content-one,
  .solution-content-two {
    .title-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      .main-title {
        margin-top: 80px;
        font-family: PingFangSC-Semibold;
        font-size: 30px;
        color: #222222;
        letter-spacing: 0;
        text-align: center;
      }
      .sub-title {
        margin-top: 5px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #3d3d3d;
        letter-spacing: 0;
        line-height: 26px;
      }
    }
  }
  .solution-content-one {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    .solution-card-container {
      // margin: 0 auto;
      padding: 50px 0 55px 0;
      width: 1100px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .solution-card-wrapper {
        margin-bottom: 25px;
        width: 350px;
        height: 513px;
        background: #ffffff;
        border: 1px solid #e9eef5;
        box-shadow: 0 2px 16px 0 rgba(71, 75, 82, 0.06);
        .solution-header {
          height: 90px;
          padding: 30px;
          background-image: linear-gradient(180deg, #ffffff 0%, #f4f5fb 100%);
          display: flex;
          align-items: center;
          .title {
            display: flex;
            align-items: center;
            img {
              width: 30px;
              height: 30px;
              margin-right: 13px;
            }
            font-family: PingFangSC-Semibold;
            font-size: 20px;
            color: #222222;
          }
        }
        .solution-body {
          padding: 10px 30px 0 30px;
          .solution-content-container {
            padding: 20px 0;
            .solution-title {
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #222222;
            }
            .solution-content {
              margin-top: 10px;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #7b8799;
            }
            &:not(:last-child) {
              border-bottom: 1px solid #eaecf2;
            }
            &:not(:first-child) {
              // margin-top: 20px;
            }
          }
        }
        .get-btn-container {
          // padding: 30px;
          .get-btn {
            margin: 10px 0 0 30px;
            width: 104px;
            height: 34px;
            border: 1px solid #0764fb;
            border-radius: 17px;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #0764fb;
            @include btn;
          }
        }
      }
    }
  }
  .solution-content-two {
    background: #f9fafc;
    .solution-card-container {
      //   padding: 0 10%;
    //   margin: 42px 0 60px 0;
      margin: 42px 0 60px;
      max-width: 1100px;
      display: flex;
      background: #ffffff;
      border: 1px solid #e9eef5;
      .solution-card-wrapper {
        flex: 1;
        padding: 40px 30px 30px 30px;
        &:not(:last-child){
            border-right: 1px solid #e9eef5;
        }
        .logo {
          margin-bottom: 16px;
          img {
            width: 30px;
            height: 30px;
          }
        }
        .card-title {
          margin-bottom: 16px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #222222;
        }
        .card-txt {
          margin-bottom: 33px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #7b8799;
        }
        .card-desc-container {
          display: flex;
          .card-desc {
            margin-right: 6px;
            padding: 3px 6px;
            border: 1px solid #e9eef5;
            border-radius: 1px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #7b8799;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/solution/components/solutionContent.vue